import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild } from '@angular/core';

import { IPaginationResponseResolver, IPaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, ITableConfig, PaginatedTableComponent } from '../../../ui';
import { IAuditableEntity } from '../../../primitives';
import { DateFormatPipe } from '../../../../../trash/shared/pipes/date-format.pipe';

@Component({
  selector: 'app-auditable-entities',
  standalone: true,
  providers: [],
  imports: [PaginatedTableComponent, CommonModule, DateFormatPipe],
  templateUrl: './auditable-entities.component.html',
  styleUrls: ['./auditable-entities.component.scss']
})
export class AuditableEntitiesComponent<
  TEntity extends IAuditableEntity<string>,
  TPaginationParameters extends IPaginationParameters
> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();
  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [
      { name: 'autoIncrementalId', displayName: 'Id' },
      ...(this.tableConfig()?.fields ?? []),
      { name: 'createdOnUtc', displayName: 'GENERAL.CREATE_ON' }
    ],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
